module.exports = __webpack_public_path__ + "static/media/so-end-slide.ec8c6690.svg";